import React, { useEffect, useState } from 'react';
import type { ReactElement } from 'react';
import cIf from 'classnames';
import { util } from '@tsinternetsale/common';

import './lite-shop-product-overview.scss';

type LiteShopProductOverviewProps = {
    pictureThumbnailURL?: string;
    productName: string;
    productDate?: Date;
    productDescription: string;
    venueName?: string;
}

export function LiteShopProductOverview({ pictureThumbnailURL, productName, productDate, productDescription, venueName }: LiteShopProductOverviewProps): ReactElement {
    const [productImageUrl, setProductImageUrl] = useState(null);

    useEffect(() => {(async () => {
        const purchaseUrl = await tsapp.getPurchaseUrl("rese");
        if (pictureThumbnailURL?.length > 0) {
            const { productImageUrl, } = util.buildProductImage(purchaseUrl, {
                homeSquareImageUrl: pictureThumbnailURL
            }, false);
            setProductImageUrl(productImageUrl);
        }
    })();}, [pictureThumbnailURL]);




    return <div className="container-fluid">
        <div className="overview">
            <div className={cIf(["overview-content", {"with-image": productImageUrl != undefined}])}>
                {productImageUrl && <img src={productImageUrl} alt="Product img" />}
                <div className="info">
                    <h3>{productName}</h3>
                    {productDescription && productName != productDescription && <p className='description'>{productDescription}</p>}
                    {productDate && <p className="date">{productDate}</p>}
                    {venueName && <p className="venuename accented-text"><i className="fas fa-map-marker-alt"></i>&nbsp;{venueName}</p>}
                </div>
            </div>
        </div>
    </div>;
}